import { NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, SharedModule } from 'primeng/api';
import { Menu, MenuModule } from 'primeng/menu';

import { CallPipe } from 'src/app/pipes/call.pipe';
import { cast, castIcon } from 'src/app/utils';

@Component({
  selector: 'app-root-menu',
  standalone: true,
  imports: [CallPipe, MenuModule, SvgIconComponent, SharedModule, NgClass],
  templateUrl: './root-menu.component.html',
  styleUrl: './root-menu.component.scss',
})
export class RootMenuComponent {
  @ViewChild(Menu, { static: false }) private menu!: Menu;

  readonly translate = inject(TranslateService);

  get cd() {
    // Due to the primeng menu change detection strategy we need to force the detection at that level
    // in order to show dynamic items
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cd = (this.menu as any).cd;
    if (cd && cd.detectChanges) {
      return cd as ChangeDetectorRef;
    }
    throw new Error('Change detection not exposed');
  }

  readonly castItem = cast<MenuItem>;
  readonly castIcon = castIcon;

  setMenuItems(menuItems: MenuItem[]) {
    this.menu.model = menuItems;
    this.cd.detectChanges();
  }

  toggleMenu(menuItems: MenuItem[], event: Event) {
    this.menu.model = menuItems;
    this.menu.toggle(event);
  }
}
